var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('BreadCrumb')], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v("受眾管理")]), _c('div', {
    staticClass: "\n          col-12 col-xl-6\n          d-flex\n          flex-column flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_vm.$permissions.has(_vm.$permissions.consts.AUDIENCE_BRANCH_CREATE) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: 'modal-simple-audience-form',
      expression: "'modal-simple-audience-form'"
    }],
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("分店受眾新增 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.AUDIENCE_CREATE) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'AudienceCreate',
        query: {
          branch_id: _vm.query.branch_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增受眾")]) : _vm._e(), _c('b-select', {
    attrs: {
      "options": _vm.branchOptions,
      "disabled": !this.checkPermission([_vm.consts.AUDIENCE_LIST_VIEW_BRANCH])
    },
    on: {
      "input": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.branch_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "branch_id", $$v);
      },
      expression: "query.branch_id"
    }
  }), _c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.audiences,
      "fields": _vm.fields,
      "busy": _vm.isLoading,
      "no-local-sorting": ""
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.AUDIENCE_LIST_VIEW]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'AudienceView',
              params: {
                audienceId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye mr-1"
        }), _vm._v("查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.AUDIENCE_MODIFY]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'AudienceEdit',
              params: {
                audienceId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v("編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.AUDIENCE_DELETE]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item.id, data.item.title);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete mr-1"
        }), _vm._v("刪除 ")]) : _vm._e(), _c('b-dropdown', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-secondary"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "mdi mdi-menu"
        })]), _vm.checkPermission([_vm.consts.AUDIENCE_LIST_VIEW]) ? _c('b-dropdown-item', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-secondary",
            "to": {
              name: 'AudienceCustomersList',
              params: {
                audienceId: data.item.id
              }
            }
          }
        }, [_vm._v("受眾名單")]) : _vm._e(), _vm.checkPermission([_vm.consts.AUDIENCE_UPDATE_CUSTOMER]) ? _c('b-dropdown-item', {
          staticClass: "ml-2",
          on: {
            "click": function click($event) {
              return _vm.handleSync(data.item.id, data.item.title);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat"
        }), _vm._v(" 更新名單")]) : _vm._e(), _vm.checkPermission([_vm.consts.AUDIENCE_SYNC_LINE]) ? _c('b-dropdown-item', {
          staticClass: "ml-2",
          on: {
            "click": function click($event) {
              return _vm.handleSyncToLine(data.item.id, data.item.title);
            }
          }
        }, [_vm._v("同步至LINE")]) : _vm._e(), _vm.checkPermission([_vm.consts.OA_PUSH_CREATE]) ? _c('b-dropdown-item', {
          staticClass: "ml-2",
          attrs: {
            "to": {
              name: 'PushMessageDetail',
              params: {
                messageID: 'create'
              },
              query: {
                audience_id: data.item.id,
                branch_id: _vm.query.branch_id
              }
            }
          }
        }, [_vm._v("群發訊息")]) : _vm._e()], 2)];
      }
    }])
  })], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-simple-audience-form",
      "title": "新增分店受眾",
      "centered": ""
    },
    on: {
      "hidden": _vm.resetModal,
      "ok": _vm.handleCreate
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v(" 確認送出 ")])];
      }
    }])
  }, [_c('form', {
    ref: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleCreate.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', [_c('b-form-select', {
    attrs: {
      "options": _vm.branchOptions
    },
    model: {
      value: _vm.branchId,
      callback: function callback($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  })], 1), _c('b-form-group', [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "placeholder": "請輸入受眾名稱"
    },
    model: {
      value: _vm.title,
      callback: function callback($$v) {
        _vm.title = $$v;
      },
      expression: "title"
    }
  })], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }